import { apiClient } from "./apiclient";

export const assignUserRole = (userId, roleId, token) =>
  apiClient.put(
    "/employee/assign-role",
    { userId, roleId },
    { headers: { Authorization: `Bearer ${token}` } }
  );

export const getAllRoles = (token) =>
  apiClient.get("/roles", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });